export const DECOMPOSITION_MODE_RISK = 'risk';
export const DECOMPOSITION_MODE_EXECUTION = 'execution';
export const DECOMPOSITION_MODE_REALIZATION = 'realization';

export const HISTORICAL_DEFAULT_DECOMPOSITION_MODE = DECOMPOSITION_MODE_EXECUTION;

export const DECOMPOSITION_MODE_CONFIG = {
    [DECOMPOSITION_MODE_RISK]: {
        label: 'Risk',
        leftKey: 'factor',
        rightKey: 'idio',
        leftLabel: 'Factor',
        rightLabel: 'Idio',
        leftColor: '#1d4ed8',
        rightColor: '#60a5fa',
    },
    [DECOMPOSITION_MODE_EXECUTION]: {
        label: 'Trading',
        leftKey: 'trading',
        rightKey: 'non_trading',
        leftLabel: 'Trading',
        rightLabel: 'Non-Trading',
        leftColor: '#f97316',
        rightColor: '#fdba74',
    },
    [DECOMPOSITION_MODE_REALIZATION]: {
        label: 'Realization',
        leftKey: 'realized',
        rightKey: 'unrealized',
        leftLabel: 'Realized',
        rightLabel: 'Unrealized',
        leftColor: '#15803d',
        rightColor: '#86efac',
    },
};

export function normalizeDecompositionMode(mode, fallback = HISTORICAL_DEFAULT_DECOMPOSITION_MODE) {
    if (mode && DECOMPOSITION_MODE_CONFIG[mode]) return mode;
    return fallback;
}
